export enum RequestPackageType {
  CANCEL = 'CancelPackage',
  REGISTER = 'InitiatePackage',
  TOPUP = 'EnterpriseTopup',
  DATACODE = 'Datacode',
}
